import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {LoginService} from '../../../services/login.service';
import {CommunicationService} from '../../../services/communication.service';
import {TranslateService} from '@ngx-translate/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomValidators } from '../../../classes/custom-validators';
import { PreRenderService } from '../../../services/pre-render.service';
@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  isTokenValid: boolean = false;
  showPasswordText: boolean = false;
  showConfirmPasswordText: boolean = false;
  token = '';

  registrationForm: FormGroup;

  constructor(private route: ActivatedRoute,
              private loginService: LoginService,
              private communicationService: CommunicationService,
              private translateService: TranslateService,
              private prerenderService: PreRenderService,
              private fb: FormBuilder,
              private router: Router) { }

  ngOnInit() {
    this.prerenderService.setPreRenderFlag(200);
    this.token = this.route.snapshot.params.id;
    this.loginService.checkPasswordToken(this.token).then(response => this.isTokenValid = response);

    this.registrationForm = this.fb.group({
      password: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', [Validators.required, Validators.minLength(6)]]
    }, { validator: CustomValidators.passwordMatcher});
  }

  onSubmit() {
    this.loginService.changeForgotPassword(this.token, this.registrationForm.get('password').value).then(response => {
      this.router.navigate(['/my-remax']).then(result => {
        this.communicationService.notifications.enableNotifications.next(true);
        this.communicationService.notifications.notificationChanged.next(this.translateService.instant('notification.password-reset'));
      });
    });
  }
}
